import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Box from 'ravenjs/lib/Box';
import KeyValuePairs from 'ravenjs/lib/KeyValuePairs';
import { getThemeProps } from 'ravenjs/utils/theme';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const DetailsSectionStyled = styled.div`
    ${getThemeProps('ObjectFieldTemplate.styles')};
`;

const TitleField = styled.label`
    color: ${MIGRATED_COLORS.grey19};
    font-size: 14px;
    font-family: Favorit;
    font-weight: 600;
    margin: 0 0 5px 10px;
    padding: 0;
`;

const DetailsSection = ({ items, itemKey, itemValue, keyValueStyles, showDivider, title }) => {
    return (
        <DetailsSectionStyled>
            <TitleField>{title}</TitleField>
            <Box borderColor={MIGRATED_COLORS.placeholder} borderRadius="0">
                <KeyValuePairs
                    items={items}
                    itemKey={itemKey}
                    itemValue={itemValue}
                    keyValueStyles={keyValueStyles}
                    keySuffix=" :"
                    showDivider={showDivider}
                />
            </Box>
        </DetailsSectionStyled>
    );
};

DetailsSection.propTypes = {
    items: PropTypes.array,
    itemKey: PropTypes.string,
    itemValue: PropTypes.string,
    keyValueStyles: PropTypes.object,
    showDivider: PropTypes.bool,
    title: PropTypes.string,
};

DetailsSection.defaultProps = {
    items: [],
    itemKey: '',
    itemValue: '',
    keyValueStyles: {},
    showDivider: false,
    title: null,
};

export default DetailsSection;
